import axios from 'axios'

const service = axios.create({
    baseURL: 'https://res.carbonhp.com/assetbundles/carbon',
    // baseURL: 'http://localhost:8080',
    timeout: 50000000
})

export default service